// @ts-strict-ignore
import type {EntryRowTypeHelpers} from 'common/query-builder/query-entry-section/row-types/types';
import {isSavedMetricEntry, QueryBehaviorEntry, QuerySuperEntry} from 'common/query-builder/query-entry-section/types';
import {PropertyFilter} from 'common/widgets/property-filter-menu/models/property-filter';

// eslint-disable-next-line import/no-cycle
import {SuperEntryRow} from './index';
import {hasEventValue, hasPropertyValue} from './utils';

function hasValidFilters(entry: QuerySuperEntry) {
  return entry.filters.every((filter) => new PropertyFilter(filter).isValid());
}

export const helpers: EntryRowTypeHelpers<QuerySuperEntry> = {
  component: SuperEntryRow,
  isPlaceholder({entry}) {
    if (isSavedMetricEntry(entry)) {
      return false;
    }
    if (!hasEventValue(entry) || !hasValidFilters(entry)) {
      return true;
    }

    if (entry.property) {
      return !hasPropertyValue(entry);
    }

    /** @todo [pablo] move all of behavior specific logic to a behavior entry type definition */
    if ((entry as QueryBehaviorEntry).entryFilter) {
      const entryFilter = new PropertyFilter((entry as QueryBehaviorEntry).entryFilter);
      return !entryFilter.isValid();
    }

    return false;
  },
  isIntermediatePlaceholder(row) {
    return this.isPlaceholder(row) && hasEventValue(row.entry);
  },
};
